import { userApi } from '@src/api/user-api'
import { AppDispatch } from '@src/store/store'
import { deleteProfileStatus } from '@src/store/ducks/user/reducer'
import { setIsAuth, setIsInitialized } from './reducer'

export const fetchMe = () => async (dispatch: AppDispatch) => {
  try {
    const result = await userApi.getMe()
    await userApi.profile()
    dispatch(setIsAuth(true))
    dispatch(deleteProfileStatus(result?.toDelete === 1))
  } catch (err: any) {
    console.error(err)
    if (err?.response?.status === 401 || err?.response?.status === 404) {
      localStorage.removeItem('Authorization')
      dispatch(setIsAuth(false))
    }
  } finally {
    dispatch(setIsInitialized())
  }
}
